<template>
  <div class="container">
    <div class="row">
      <h1 class="text-center main-title" v-html="$t('title.news')">
      新闻<em>资讯</em>
      <span>News</span>
      </h1>
      <!-- <ul class="clearfix aside text-center">
        <li v-for="(item,index) in newsort" class="aside-title">
          <router-link :to="'/news/'+item.id" key="index" exact>{{item.category}}</router-link>
        </li>
      </ul> -->

      <div class="col-md-12">
        <h2 class="text-center news-title">{{content.title}}</h2>
        <p class="text-center">
          发布日期：{{content.date}}<i class="glyphicon glyphicon-eye-open" style="margin-left:10px">：{{content.hits}}</i>
        </p>
        <div class="main-content" v-html="content.body"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs';

export default {
  name: "ndetail",
   metaInfo() {
    return {
      title: this.pageName
    }; // set a title
  },
  data() {
    return {
      content:{}
    };
  },
  created(){
   console.log(this.$route.params);
 
  },
  mounted() {
   var newid = this.$route.params.pId;
   //console.log(this.$route.params.pId)
   axios.post('http://www.hzjingbao.cn/api/News',qs.stringify({ id: newid , lang: this.$i18n.locale}),{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
  .then(res=>{
    console.log(res)
    this.content = res.data
  })
  .catch(error=>{
    console.log(error)  
  })
  },
  computed:{
     pageName(){
      return this.$t("nav[3].name");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/ndetail.vue